/*
  Keeps the "selected colour" caption in sync with the chosen swatch.

  Delegated from the document so it survives Dawn re-rendering the variant
  picker after a variant change, and so a single listener covers every colour
  option on the page (some products have both a Body Color and an Antler Color).
*/
document.addEventListener('change', function (event) {
  var input = event.target;
  if (!input || !input.matches || !input.matches('input[type="radio"]')) return;

  var group = input.closest('fieldset');
  if (!group) return;

  var caption = group.querySelector('[data-color-swatch-selected]');
  if (!caption) return;

  caption.textContent = input.value;
});
